export const event = {
    1: 'Dentist',
    2: 'Farrier',
    3: 'BodyWork',
    4: 'Vet',
    5: 'Worming',
    6: 'Injection',
    7: 'Medication',
    8: 'Feed',
    9: 'Results',
    10: 'Misc',
    11: 'Work',
    12: 'Broodmare',
    99: 'Other'
}

export const getEventById = (query: { _ID: number }) => {
    return event[query._ID] as string
}

export const getEventByName = (query: { name: string }) => {
    return Object.keys(event).find(key => event[key] === query.name);
}